// extracted by mini-css-extract-plugin
export default {"editButton":"PayrollMethod_editButton__pbrcE","TableBody":"PayrollMethod_TableBody__VdmV8","deleteButton":"PayrollMethod_deleteButton__9Tjnz"};